<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" @submit.native.prevent class="demo-form-inline h-formBorder" style="margin-left:-0.5rem">
                                <el-form-item label="物料编码/描述" style="width: 55%;">
                                    <el-input clearable v-model="q.wlcodename"></el-input>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:40%;">
                                    <el-button class="w-key-btn" type="primary"  @click="handleFilter">搜索</el-button>
                                    <el-button class="w-key-btn" type="primary"  @click="choseSelected">选择</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
								:border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="matecode"
                                    label="物料号"
                                    width="170"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="matedes"
                                    label="物料描述"
                                    width="180"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="cpdlcode"
                                    label="产品大类编码"
                                    width="90"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="cpdlname"
                                    label="产品大类名称"
                                    width="150"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="dwcode"
                                    label="单位编码"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="dwname"
                                    label="单位名称"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="jizhj"
                                    label="基准价"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="djyxq"
                                    label="有效期"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="companycode"
                                    label="公司编码"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="querypage"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  wlcodename:null,
                  usercode:null,
                  currencyCode:null,
                  xmtype:null,
                  channel:null,
                  areaCode:null,
              },
              ttdata:null,
              lists:[]
          }
        },
        methods: {
            handleFilter(){
                this.querypage();
            },
            querypage(p){
                ss.wuliaoselect.wuliaoxm(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            handleSelectionChange(lists){
                if(this.oneflag){
                    this.$emit('choseObj', lists[0])
                }else{
                    this.lists = lists;
                }
            },
            choseSelected(){
                this.$emit('choseObj', this.lists)
            },
        },
        mounted(){
            this.q.usercode = this.UserCode
            //项目编号
            this.q.xmtype = this.XmType
            this.q.currencyCode = this.currencyCode
            this.q.channel = this.channel
            this.q.areaCode = this.areaCode
            this.querypage()
        },
        computed: {
            UserCode:function () {
                return this.usercode;
            },
            XmType:function () {
                return this.xmtype
            },
            currencyCode:function () {
                return this.currency
            },
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            usercode:{
                type:String,
            },
            //订单类型
            xmtype:{
                type:String,
            },
            currency:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
            channel:{
              type:String,
            },
            areaCode:{
              type:String,
            },
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
<style scoped="scoped">
	.w-key-btn {
		padding: 0.1rem 0.25rem !important;
	}
</style>
